function lineByLine(el) {
  const wordByWord = el.innerText.trim().split(' ');
  let pWithSpans = '';

  for (let i = 0; i < wordByWord.length; i++) {
    pWithSpans += `<span>${wordByWord[i]}</span> `;
  }

  el.innerHTML = pWithSpans;

  const words = Array.from(el.querySelectorAll('span'));
  let prevOffset = 0;
  let row = 0;
  let html = `<span class="row-split" style="--i:${row}"><span>`;

  for (let word of words) {
    const currentOffset = word.getBoundingClientRect().left;

    if (currentOffset <= prevOffset) {
      row++;
      html = html.trim();
      html += `</span></span><span class="row-split" style="--i:${row}"><span> ${word.innerHTML} `;
    } else {
      html += `${word.innerHTML} `;
    }

    prevOffset = currentOffset;
  }

  html = html.trim();
  html += '</span></span>';
  el.innerHTML = html;
}

function debounce(func, wait = 100) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

document.addEventListener('DOMContentLoaded', () => {
  const elements = document.querySelectorAll('.title-split');
  const titles = document.querySelectorAll('.title-split');

  elements.forEach(el => lineByLine(el));

  // window.addEventListener('resize', debounce(() => {
  //   titles.forEach(title => {
  //     title.style.transition = 'opacity .5s ease';
  //     title.style.opacity = '0';
  //   });
  //   elements.forEach(el => {
  //     el.style.transition = 'opacity 1s linear';
  //     el.style.opacity = '0';
  //   });
  
  //   setTimeout(() => {
  //     elements.forEach(el => {
  //       lineByLine(el);
  
  //       requestAnimationFrame(() => {
  //         el.style.transition = 'opacity 1s linear';
  //         el.style.opacity = '1';
  //       });
  //     });
  //   }, 50);
  // }, 200));
  

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;
  
        if (!el.classList.contains('animated-once')) {
          el.classList.add('active');
          el.classList.add('has-intersected');
          el.classList.add('animated-once');
  
          setTimeout(() => {
            el.classList.remove('active');
          }, 3000);
        }
  
        obs.unobserve(el);
      }
    });
  }, {
    threshold: 0.2
  });
  


document.querySelectorAll('.intersect.title-split').forEach(el => observer.observe(el));
});
